import './BlockFooter.css';

function BlockFooter(props: {
    paragraph: string
}) {
    return (
        <div className='block-footer df fdc aic jcsb'>
            <p className='note'>{props.paragraph}</p>
        </div>
    )
}

export default BlockFooter;